export enum UserRole {
  ADMIN = 'ADMIN',
  CLINIC = 'CLINIC',
  DOCTOR = 'DOCTOR',
  READ_ONLY = 'READ_ONLY',
}

export enum UserStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
}

export type User = {
  id: string;
  email: string;
  name: string;
  role: UserRole;
  status: UserStatus;
};
